import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchResults } from '../searchResults';
import { Circle } from './circle';
import { City } from './city';

@JsonObject('CircleSearchResults')
export class CircleSearchResults extends SearchResults {
    @JsonProperty('results', [Circle])
    results: Circle[] = [];
}

@JsonObject('CitySearchResults')
export class CitySearchResults extends SearchResults {
    @JsonProperty('results', [City])
    results: City[] = [];
}
